import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ReorderExercisesModal from "./ReorderExercisesModal";
import "./ExerciseList.css";
import VideoPlayerOverlay from "../common/VideoPlayerOverlay";

const ExerciseList = ({
  isdisable,
  wid,
  setCmodal,
  showExcercise,
  apiexercises,
  setReorder,
  openMergeModal,
  reorder,
  mergeexercises,
  workoutData,
  formateSetsinputs,
  addType,
  setAddType,
  setQuickSet,
  handleExerciseClick,
  handleAddType,
  deleteEx,
  duplicateEx,
  pid,
  widd,
  openRemoveModal,
  reOrderexcercise,
  payLoad,
  onDragEnd,
  detailset,
}) => {
  const [showReorderModal, setShowReorderModal] = useState(false);
  const [videoOverlayOpen, setVideoOverlayOpen] = useState(false);
  const [videoOverlayUrl, setVideoOverlayUrl] = useState("");
  const [videoOverlayTitle, setVideoOverlayTitle] = useState("Video");

  const handleReorderModal = () => {
    console.log("Reorder Modal Opened - exercises:", apiexercises);
    console.log("Setting showReorderModal to true");
    setShowReorderModal(true);
  };

  const openVideoOverlay = (url, title) => {
    setVideoOverlayUrl(url);
    setVideoOverlayTitle(title || "Video");
    setVideoOverlayOpen(true);
  };

  const closeVideoOverlay = () => {
    setVideoOverlayOpen(false);
    setVideoOverlayUrl("");
  };

  const handleReorderSave = (reorderedExercises) => {
    // Update the exercises order and save
    reOrderexcercise(reorderedExercises);
    setShowReorderModal(false);
  };
  return (
    <div className="pw_exercise-list-container">
      {(!isdisable || wid) && (
        <div className="pw_exercise-actions-header">
          <div className="pw_action-buttons">

            <button
              className="pw_action-btn pw_action-btn-secondary"
              onClick={() => showExcercise()}
            >
              <i className="fa fa-search" style={{ marginRight: '8px' }}></i>
              Add Exercise
            </button>
            <button
              className="pw_action-btn pw_action-btn-primary"
              onClick={() => setCmodal(true)}
            >
              <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
              Create New Exercise
            </button>
            {apiexercises.length > 0 && (
              <button
                className="pw_action-btn pw_action-btn-tertiary"
                onClick={handleReorderModal}
              >
                <i className="fa fa-sort" style={{ marginRight: '8px' }}></i>
                Re-order Exercises
              </button>
            )}
            {apiexercises.length > 1 && (
              <button
                className="pw_action-btn pw_action-btn-merge"
                onClick={() => openMergeModal()}
                title="Merge exercises together"
              >
                <i className="fa fa-object-group" style={{ marginRight: '8px' }}></i>
                Merge Exercises
              </button>
            )}
          </div>
        </div>
      )}
      
      {apiexercises.length === 0 ? (
        <div className="pw_empty-exercises">
          <div className="pw_empty-icon">
            <i className="fa fa-dumbbell"></i>
          </div>
          <h3 className="pw_empty-title">No Exercises Added</h3>
          <p className="pw_empty-description">
            Start building your workout by adding exercises. You can create new exercises or add from the library.
          </p>
          {(!isdisable || wid) && (
            <div className="pw_empty-actions">
              <button
                className="pw_action-btn pw_action-btn-primary"
                onClick={() => setCmodal(true)}
              >
                <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
                Create New Exercise
              </button>
              <button
                className="pw_action-btn pw_action-btn-secondary"
                onClick={() => showExcercise()}
              >
                <i className="fa fa-search" style={{ marginRight: '8px' }}></i>
                Browse Library
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="pw_exercises-grid">
          {mergeexercises?.map((mergedexercise, mergeIndex) => (
            <div key={mergeIndex} className="pw_exercise-group">
              {mergedexercise?.workout_exercises?.length > 1 && (
                <div className="pw_group-header">
                  <div className="pw_group-badge">
                    <i className="fa fa-object-group"></i>
                    <span>Merged Exercise Group</span>
                  </div>
                  {mergedexercise?.video && (
                    <button 
                      type="button"
                      onClick={() => openVideoOverlay(mergedexercise.video, "Group Video")}
                      className="pw_group-video"
                      title="Watch group demonstration video"
                      style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                    >
                      <i className="fa fa-play-circle"></i>
                    </button>
                  )}
                </div>
              )}

              {mergedexercise?.workout_exercises?.length > 1
                ? mergedexercise?.workout_exercises?.map(
                    (exc, mainidex) =>
                      apiexercises?.map((item, index) =>
                        item.id == exc?.workout_exercise_id ? (
                          <ExerciseItem
                            key={item.id}
                            item={item}
                            mainidex={mainidex}
                            mergedexercise={mergedexercise}
                            workoutData={workoutData}
                            formateSetsinputs={formateSetsinputs}
                            addType={addType}
                            setAddType={setAddType}
                            setQuickSet={setQuickSet}
                            handleExerciseClick={handleExerciseClick}
                            handleAddType={handleAddType}
                            deleteEx={deleteEx}
                            duplicateEx={duplicateEx}
                            openRemoveModal={openRemoveModal}
                            wid={wid}
                            widd={widd}
                            pid={pid}
                            detailset={detailset}
                            isMerged={true}
                            onPlayVideo={(url, title) => openVideoOverlay(url, title || item?.name)}
                          />
                        ) : null
                      )
                  )
                : mergedexercise?.workout_exercises?.map((exc) =>
                    apiexercises?.map((item) =>
                      item.id == exc?.workout_exercise_id ? (
                        <ExerciseItem
                          key={item.id}
                          item={item}
                          workoutData={workoutData}
                          formateSetsinputs={formateSetsinputs}
                          addType={addType}
                          setAddType={setAddType}
                          setQuickSet={setQuickSet}
                          handleExerciseClick={handleExerciseClick}
                          handleAddType={handleAddType}
                          deleteEx={deleteEx}
                          duplicateEx={duplicateEx}
                          wid={wid}
                          widd={widd}
                          pid={pid}
                          detailset={detailset}
                          isMerged={false}
                          onPlayVideo={(url, title) => openVideoOverlay(url, title || item?.name)}
                        />
                      ) : null
                    )
                  )}
            </div>
          ))}
        </div>
      )}

      {/* Reorder Exercises Modal */}
      {showReorderModal && (
        <ReorderExercisesModal
          exercises={apiexercises}
          onSave={handleReorderSave}
          onCancel={() => setShowReorderModal(false)}
        />
      )}

      {/* Video Overlay */}
      <VideoPlayerOverlay
        isOpen={videoOverlayOpen}
        url={videoOverlayUrl}
        title={videoOverlayTitle}
        onClose={closeVideoOverlay}
      />
    </div>
  );
};

const ExerciseItem = ({
  item,
  mainidex,
  mergedexercise,
  workoutData,
  formateSetsinputs,
  addType,
  setAddType,
  setQuickSet,
  handleExerciseClick,
  handleAddType,
  deleteEx,
  duplicateEx,
  openRemoveModal,
  wid,
  widd,
  pid,
  detailset,
  isMerged,
  onPlayVideo,
}) => {
  const [showActions, setShowActions] = useState(false);

  const getWorkoutTypeAction = () => {
    switch (workoutData.workout_type) {
      case "AMRAP":
        return () => setQuickSet((pre) => !pre);
      case "EMOM":
        return () => handleAddType(item);
      default:
        return () => handleExerciseClick(item);
    }
  };

  const getWorkoutTypeIcon = () => {
    switch (workoutData.workout_type) {
      case "AMRAP":
        return "fa-clock";
      case "EMOM":
        return "fa-stopwatch";
      case "FOR TIME":
        return "fa-timer";
      case "RESISTANCE":
        return "fa-dumbbell";
      default:
        return "fa-play-circle";
    }
  };

  return (
    <div className={`pw_exercise-card ${isMerged ? 'pw_merged-exercise' : ''}`}>
      {addType && (
        <div className="pw_action-modal-overlay">
          <div className="pw_action-modal">
            <div className="pw_action-modal-header">
              <h4>Edit Exercise Sets</h4>
              <button 
                className="pw_modal-close" 
                onClick={() => setAddType(false)}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
            <div className="pw_action-modal-content">
              <button
                className="pw_action-modal-btn pw_primary"
                onClick={() => {
                  setQuickSet((pre) => !pre);
                  setAddType(false);
                }}
              >
                <i className="fa fa-bolt" style={{ marginRight: '8px' }}></i>
                Quick Edit
              </button>
              <button
                className="pw_action-modal-btn pw_secondary"
                onClick={() => {
                  handleExerciseClick(detailset);
                  setAddType(false);
                }}
              >
                <i className="fa fa-edit" style={{ marginRight: '8px' }}></i>
                Edit Sets Individually
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="pw_exercise-header">
        <div className="pw_exercise-info">
          <h3 
            className="pw_exercise-name" 
            onClick={getWorkoutTypeAction()}
          >
            {item?.name}
          </h3>
          
          <div className="pw_exercise-meta">
            <div className="pw_meta-item">
              <i className="fa fa-list"></i>
              <span>
                Sets: {workoutData?.workout_type === "AMRAP" ? (
                  <span className="pw_highlight">Max</span>
                ) : (
                  <span className="pw_highlight">{item?.sets?.length || 0}</span>
                )}
              </span>
            </div>
            
            {Object.entries(formateSetsinputs(item?.sets) || {}).map(
              ([fieldName, values]) => (
                <div key={fieldName} className="pw_meta-item">
                  <i className="fa fa-chart-bar"></i>
                  <span className="pw_field-name">{fieldName}:</span>
                  <span className="pw_field-values">{values.join("/")}</span>
                  <span className="pw_field-unit">
                    {fieldName === "WEIGHT" ? "kgs" :
                     fieldName === "DISTANCE" || fieldName === "Distance" || fieldName === "Jump Row" ? "meters" :
                     fieldName === "CALORIES" ? "calories" :
                     fieldName === "DURATION" ? "minutes" :
                     fieldName === "REPETITIONS" ? "reps" : ""}
                  </span>
                </div>
              )
            )}
          </div>
        </div>

        <div className="pw_exercise-actions">
          {isMerged && mainidex === 0 && (
            <div className="pw_merge-indicator">
              <button
                className="pw_action-btn pw_unmerge"
                onClick={() => openRemoveModal(mergedexercise?.id)}
                title="Unmerge exercises"
              >
                <i className="fa fa-object-ungroup"></i>
              </button>
            </div>
          )}

          <div className="pw_action-buttons">
            <button
              className="pw_action-btn pw_edit"
              onClick={getWorkoutTypeAction()}
              title="Edit exercise"
            >
              <i className="fa fa-edit"></i>
            </button>
            
            <button
              className="pw_action-btn pw_duplicate"
              onClick={() => duplicateEx(pid, wid || widd, item?.id)}
              title="Duplicate exercise"
            >
              <i className="fa fa-copy"></i>
            </button>
            
            <button
              className="pw_action-btn pw_delete"
              onClick={() => deleteEx(wid || widd, item?.id)}
              title="Delete exercise"
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>

          {item?.video && (
            <button
              type="button"
              className="pw_video-link"
              onClick={() => onPlayVideo?.(item.video, item?.name)}
              title="Watch demonstration video"
              style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
            >
              <i className="fa fa-play-circle"></i>
            </button>
          )}
        </div>
      </div>

      {isMerged && (
        <div className="pw_merged-badge">
          <i className="fa fa-link"></i>
          <span>Part of merged group</span>
        </div>
      )}
    </div>
  );
};

export default ExerciseList;
